import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

class ModuloService extends BaseService {
  constructor() {
    super(`${ConfigApi.edicaoURL}`);
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.limit = 11;
    this.page = 0;
  }
}
export default new ModuloService();
